// src/components/RankCarRow.jsx
import React from 'react';

function RankCarRow({ car, rank, onClick }) {
    const { id, name, imageUrl } = car;

    return (
        <div 
            className="rank-car-row relative bg-white rounded-lg shadow-sm cursor-pointer"
            onClick={() => onClick(id)}
        >
            {/* Badge is now the first element */}
            <div className="rank-badge-container">
                {rank && <span className="rank-badge">{rank}</span>}
            </div>
            
            {/* Image is full width */}
            <img 
                src={imageUrl} 
                alt={name} 
                className="w-full h-auto object-cover"
            />
            
        </div>
    );
}

export default RankCarRow;